(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productV1JSON").textContent);
    // starting activeVariant comes from liquid; replaced by server fetch when options change
    let activeVariant = JSON.parse(section.querySelector(".productV1VariantJSON").textContent);

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

        // one swiper per variant, stacked; only the active variant's swiper is visible.
        // building a Swiper per variant up front blocks the main thread on large products, so init lazily
    const swiperMap = new Map();

    // build (or return the cached) swiper for a variant's visual block
    function initSwiper(visual) {
        const variantId = visual.dataset.id;
        if (swiperMap.has(variantId)) {
            return swiperMap.get(variantId);
        }

        const swiperEl = visual.querySelector(".productV1VisualSwiper");
        if (!swiperEl) return null;

        // thumbnail strip is its own swiper; slidesPerGroup is 1 so we can nudge it
        // by single slides (see keepThumbInView). the arrows still page a full view
        const thumbsEl = visual.querySelector(".productV1VisualThumbs");
        const thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 10,
            watchOverflow: true,
            // slides are buttons w/ their own aria labels
            a11y: false,
            breakpoints: {
                801: {slidesPerView: 5},
            },
        });

        // page the thumbs a full view per arrow click, and mirror the lock/disabled
        // visibility the navigation module would otherwise manage for the arrows
        const thumbsPrev = thumbsEl.querySelector(".productV1VisualThumbsNavPrev");
        const thumbsNext = thumbsEl.querySelector(".productV1VisualThumbsNavNext");

        function updateThumbsNav() {
            thumbsPrev.classList.toggle("swiper-button-lock", thumbsSwiper.isLocked);
            thumbsNext.classList.toggle("swiper-button-lock", thumbsSwiper.isLocked);
            thumbsPrev.classList.toggle("swiper-button-disabled", thumbsSwiper.isBeginning);
            thumbsNext.classList.toggle("swiper-button-disabled", thumbsSwiper.isEnd);
        }

        thumbsPrev.addEventListener("click", () => {
            thumbsSwiper.slideTo(thumbsSwiper.activeIndex - Math.ceil(thumbsSwiper.params.slidesPerView));
        });
        thumbsNext.addEventListener("click", () => {
            thumbsSwiper.slideTo(thumbsSwiper.activeIndex + Math.ceil(thumbsSwiper.params.slidesPerView));
        });
        thumbsSwiper.on("slideChange", updateThumbsNav);
        thumbsSwiper.on("update", updateThumbsNav);
        thumbsSwiper.on("resize", updateThumbsNav);
        updateThumbsNav();

        // nudge the strip by the minimum amount so the active thumb keeps 2
        // thumbnails after it (or 2 before it when moving back), clamped at the ends
        function keepThumbInView(index) {
            const perView = Math.ceil(thumbsSwiper.params.slidesPerView);
            const maxFirst = Math.max(0, thumbsSwiper.slides.length - perView);
            const first = thumbsSwiper.activeIndex;
            const last = first + perView - 1;
            let target = first;
            if (index > last - 2) {
                target = index - perView + 3;
            } else if (index < first + 2) {
                target = index - 2;
            }
            target = Math.max(0, Math.min(target, maxFirst));
            if (target !== first) {
                thumbsSwiper.slideTo(target);
            }
        }

        // mirror the active slide onto the thumb strip and keep it framed
        function syncThumb(index) {
            visual.querySelector(".productV1VisualThumbsSlide.active")?.classList.remove("active");
            visual.querySelectorAll(".productV1VisualThumbsSlide")[index]?.classList.add("active");
            keepThumbInView(index);
        }

        const swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoHeight: true,
            // the dots only show position: the thumbnail strip (visible at every width) is the
            // tap and keyboard control, so the dots stay 7px and need no 24px target (WCAG 2.5.8)
            pagination: {
                el: swiperEl.querySelector(".productV1VisualSwiperPagination"),
                clickable: false,
            },
            on: {
                // keep the thumb strip in sync as the main slide changes
                slideChange: function () {
                    syncThumb(this.realIndex);
                },
            },
        });

        // clicking a thumb jumps the main swiper to that slide
        visual.querySelectorAll(".productV1VisualThumbsSlide").forEach(thumb => {
            thumb.addEventListener("click", function () {
                swiper.slideToLoop(parseInt(this.dataset.index));
            });
        });

        // set the initial active thumb and framing
        syncThumb(swiper.realIndex);

        swiperMap.set(variantId, swiper);

        return swiper;
    }

    // the active variant's own block, or the shared fallback block when it has no gallery of its own
    function visualFor(variantId) {
        return section.querySelector(`.productV1VisualVariant[data-id="${variantId}"]`)
            || section.querySelector('.productV1VisualVariant[data-id="fallback"]');
    }

    // init only the active variant on load; the rest build on first activation
    const activeVisual = visualFor(activeVariant.id);
    if (activeVisual) {
        initSwiper(activeVisual);
    }

    function updateVisual() {
        const activeVisual = visualFor(activeVariant.id);
        section.querySelectorAll(".productV1VisualVariant").forEach(visual => {
            const isActive = visual === activeVisual;
            visual.classList.toggle("active", isActive);
            if (isActive) {
                // build the swiper on first activation, then re-measure now that it's visible
                initSwiper(visual)?.update();
            }
        });
    }

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(err => console.error("updateProduct failed:", err));
        });
    })

    /**************
     Upsell URL Param
     ***************/
    const UPSELL_PARAM = "option";

    // used below to delete param from url if it's the default selection
    const defaultUpsellInput = section.querySelector(".pdpUpsellHeaderInput");

    // reflect the selected upsell back into the url
    function syncUpsellUrl() {
        const selected = section.querySelector(".pdpUpsellHeaderInput:checked");
        const url = new URL(window.location.href);
        // if default selection delete the param
        if (!selected || selected === defaultUpsellInput) {
            url.searchParams.delete(UPSELL_PARAM);
        } else {
            url.searchParams.set(UPSELL_PARAM, selected.dataset.handle);
        }
        window.history.replaceState({}, "", url);
    }

    // keep the url in sync whenever the customer switches upsell
    section.querySelectorAll(".pdpUpsellHeaderInput").forEach(input => {
        input.addEventListener("change", syncUpsellUrl);
    });

    /**************
     Render Price
     ***************/

    // the variant a bundle card adds to the cart: the PDP card follows the active variant, a
    // color picker its chosen variant, anything else the card's base variant. Shared by the price
    // and addToCart, because the price depends on which cards end up on the same cart line.
    function upsellCardVariant(card) {
        const picker = card.querySelector(".pdpUpsellVariantPicker");
        if (picker && picker.dataset.pdp === "true") {
            return activeVariant.id;
        }
        if (picker && !Number.isNaN(parseInt(picker.dataset.variant))) {
            return parseInt(picker.dataset.variant);
        }
        return parseInt(card.dataset.variant);
    }

    // total one upsell's cards: the PDP card tracks the live active variant, a card with a
    // color picker uses its chosen variant, and a picker-less card (no color options, e.g.
    // a kit) uses its own base price so it still counts toward the total. Returns the raw sums
    // before any bundle discount, the cards themselves (variant, unit price and the card element,
    // whose own data-dp-eligible says whether a scoped code covers it; payableTotal prices them
    // line by line), plus the upsell's own discount percentage.
    function computeUpsellTotal(upsell) {
        let lines = [];
        if (upsell) {
            upsell.querySelectorAll(".pdpUpsellItem").forEach(card => {
                const picker = card.querySelector(".pdpUpsellVariantPicker");
                const variant = upsellCardVariant(card);

                // the PDP-product card always follows the active variant
                if (picker && picker.dataset.pdp === "true") {
                    lines.push({variant, node: card, price: activeVariant.price, compare: activeVariant.compare_at_price || 0});
                    return;
                }

                // default to the card's base variant, then let a color picker override it
                let linePrice = parseInt(card.dataset.price) || 0;
                let lineCompare = parseInt(card.dataset.compare) || 0;
                if (picker && !Number.isNaN(parseInt(picker.dataset.price))) {
                    linePrice = parseInt(picker.dataset.price);
                    lineCompare = parseInt(picker.dataset.compare) || 0;
                }
                lines.push({variant, node: card, price: linePrice, compare: lineCompare});
            });
        }

        // no bundle cards (product_only, kit_link, or nothing selected): price the active variant
        if (lines.length === 0) {
            lines.push({variant: activeVariant.id, price: activeVariant.price, compare: activeVariant.compare_at_price || 0});
        }

        // sum the line prices; keep each line's own compare-at so real product sales still strike through
        let realPrice = 0;
        let comparePrice = 0;
        lines.forEach(line => {
            realPrice += line.price;
            comparePrice += Math.max(line.compare, line.price);
        });

        const discount = parseInt(upsell?.querySelector(".pdpUpsellHeaderInput")?.dataset.discount, 10) || 0;
        return {realPrice, comparePrice, discount, lines};
    }

    // What the customer actually pays for an upsell: the bundle's own discount AND any discount
    // code on the session, combined under Shopify's own stacking rules and priced line by line,
    // the way the cart will price it (bundleFor in assets/theme-discount.js). Pricing the total
    // instead read 1-4 cents under the cart. window.OhSnapDiscount is published synchronously
    // from <head> (snippets/discount-rules.liquid), so this is safe on the very first render and
    // needs no readiness check; the fallbacks cover an older copy of that snippet and the feature
    // being stripped from the theme entirely, not a load-order race.
    function payableTotal(total) {
        if (window.OhSnapDiscount?.bundleFor) {
            return window.OhSnapDiscount.bundleFor(total.lines, total.discount, section);
        }
        if (window.OhSnapDiscount) {
            return window.OhSnapDiscount.bestFor(total.realPrice, total.discount, section);
        }
        return Math.round(total.realPrice * (1 - total.discount / 100));
    }

    // price the selected upsell card
    function renderPrice() {
        const compareEl = section.querySelector(".productV1ContentSellingPriceCompare");
        const realEl = section.querySelector(".productV1ContentSellingPriceReal");
        const selected = section.querySelector(".pdpUpsellHeaderInput:checked");

        const total = computeUpsellTotal(selected?.closest(".pdpUpsell"));
        const comparePrice = total.comparePrice;
        let realPrice = total.realPrice;

        // apply the bundle's own discount (from the upsell metaobject, via data-discount) so the headline
        // price matches the "% off" badge; the same percentage routes to the Discount Kit bucket at checkout.
        // payableTotal also folds in a discount code on the session, so the headline price is what the
        // customer will actually be charged rather than a list price the checkout then contradicts.
        realPrice = payableTotal(total);

        // show the compare price only when it beats the real price, otherwise hide it. The amount
        // goes beside the visually hidden "Regular price" label, not over it.
        if (compareEl) {
            const compareText = comparePrice > realPrice ? price(comparePrice) : "";
            (compareEl.querySelector("[data-compare-amount]") || compareEl).textContent = compareText;
            compareEl.hidden = !compareText;
        }
        if (realEl) {
            realEl.textContent = price(realPrice);
        }

        refreshCompareSavings();
    }

    // hidden A/B-test badge on every upsell: its discounted total's savings measured against
    // the full compare-at total (display:none in CSS until a test unhides it)
    function refreshCompareSavings() {
        section.querySelectorAll(".pdpUpsell").forEach(upsell => {
            const badge = upsell.querySelector(".pdpUpsellHeaderBadgesCompareSavings");
            if (!badge) {
                return;
            }

            const total = computeUpsellTotal(upsell);
            const comparePrice = total.comparePrice;
            const discountedTotal = payableTotal(total);
            // nearest whole percent, then rounded UP to the next multiple of 5 (38% -> 40%)
            const rawSavings = comparePrice > 0 ? Math.round((comparePrice - discountedTotal) / comparePrice * 100) : 0;
            const savings = Math.ceil(rawSavings / 5) * 5;
            badge.textContent = savings > 0 ? savings + "% Off" : "";
        });
    }

    /**************
     Update Product
     ***************/

    async function updateProduct() {

        // find active variant
        activeVariant = await getActiveVariant();

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productV1ContentATC").disabled = true;
            section.querySelector(".productV1ContentATCText").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        updateVisual();

        // keep the active PDP product's upsell card(s) in sync with the selected variant
        syncPdpPickers();

        /**************
         Price
         ***************/

        renderPrice();

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV1ContentATC").disabled = false;
            section.querySelector(".productV1ContentATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productV1ContentATC").disabled = true;
            section.querySelector(".productV1ContentATCText").textContent = "Sold Out";
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    // The cart reconcile lands after first paint, so a session whose discount was not yet known
    // (or was optimistic and turned out wrong) re-prices here rather than showing a stale figure.
    document.addEventListener("discount:changed", renderPrice);


    /**
     * Fetches the active variant based on the selected options.
     * If there are more than 250 variants, it makes a request to the server to fetch the active variant since Shopify's storefront API has a limit of 250 variants per product.
     * @returns {Promise<Object>} The active variant object
     */
    async function getActiveVariant() {
        // Fetch variant when exceeding Shopify's 250 variant limit
        if (product.variants.length >= 250) {
            const optionIDs = [];
            section.querySelectorAll(".productV1ContentOptionsItemValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.id);
            });
            const response = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());
            return response.active_variant;
        }

        // If there's only one variant, return it immediately
        if (product.variants.length === 1) {
            return product.variants[0];
        }

        // Gather selected values
        const options = [];
        section.querySelectorAll('.productV1ContentOptionsItem').forEach(group => {
            options.push(group.querySelector('input:checked').value);
        });

        // Find matching variant and return it
        return product.variants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        );
    }

    /**************
     Product ATC
     ***************/

    async function addToCart() {
        // the selected upsell card decides what gets added
        const selected = section.querySelector(".pdpUpsellHeaderInput:checked");

        // kit_link cards navigate to the bundle builder instead of adding to cart
        if (selected && selected.dataset.type === "kit_link") {
            const link = selected.closest(".pdpUpsell").querySelector(".pdpUpsellBodyKitLinkButton");
            if (link) {
                window.location.href = link.href;
            }
            return;
        }

        // add loading animation
        section.querySelector(".productV1ContentATC").classList.add("loading");

        // tag bundle lines with the bundle's discount percentage so the matching Discount Kit bucket applies it; a normal add carries no tag and stays full price
        // _bundle_id groups every line of this one bundle so removing a line later can un-bundle only its own siblings (see updateCartItem in theme-mini-cart.js)
        let bundleProperties = null;
        if (selected) {
            const bundleDiscount = parseInt(selected.dataset.discount, 10);
            if (bundleDiscount > 0) {
                const bundleID = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
                bundleProperties = {_bundle: String(bundleDiscount), _bundle_id: bundleID};
            }
        }

        // build the line items: one per bundle card, mirroring renderPrice's per-card logic so a
        // picker-less kit card is still added; fall back to the active variant when there are no cards
        let items = [];
        if (selected) {
            selected.closest(".pdpUpsell").querySelectorAll(".pdpUpsellItem").forEach(card => {
                // the same variant the price was worked out for (upsellCardVariant)
                const item = {quantity: 1, id: upsellCardVariant(card)};
                if (bundleProperties) {
                    item.properties = bundleProperties;
                }
                items.push(item);
            });
        }
        if (items.length === 0) {
            const item = {quantity: 1, id: activeVariant.id};
            if (bundleProperties) {
                item.properties = bundleProperties;
            }
            items.push(item);
        }

        // add product
        await addProduct({items: items});

        // refresh the in-memory cart behind the button spinner so the drawer opens fully populated
        await refreshCart();

        // remove loading animation
        section.querySelector(".productV1ContentATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV1ContentATC').addEventListener("click", addToCart);

    /**************
     Product Options
     ***************/

    // update displayed color name when swatch selection changes
    section.querySelectorAll(".productV1ContentOptionsItemValuesLabelInput").forEach(function (input) {
        input.addEventListener("change", function () {
            const item = this.closest(".productV1ContentOptionsItem");
            const selectedLabel = item.querySelector(".productV1ContentOptionsItemLabelSelected");
            if (selectedLabel) {
                selectedLabel.textContent = this.value;
            }
        });
    });

    // mobile: pulse swatch scale on tap (avoids stuck :hover scale on iOS)
    const tapPulseTimers = new WeakMap();
    section.addEventListener("click", function (e) {
        const trigger = e.target.closest(".productV1ContentOptionsItemValuesLabel, .pdpUpsellVariantPickerPopoverSwatch");
        if (!trigger) return;
        const swatch = trigger.querySelector(".productV1ContentOptionsItemValuesLabelSwatch, .pdpUpsellVariantPickerPopoverSwatchPreview");
        if (!swatch) return;
        clearTimeout(tapPulseTimers.get(swatch));
        swatch.classList.add("tapPulse");
        tapPulseTimers.set(swatch, setTimeout(() => swatch.classList.remove("tapPulse"), 150));
    });

    /**************
     Product Description
     ***************/

    const description = section.querySelector(".productV1ContentDescription");
    if (description) {
        const descriptionBody = description.querySelector(".productV1ContentDescriptionBody");

        // only show the toggle when the text overflows its 4-line clamp (width-aware)
        function syncDescriptionToggle() {
            if (!descriptionBody) return;
            // Expanded, nothing is clipped by definition — recomputing here would drop
            // hasToggle and take SHOW LESS with it.
            if (description.classList.contains("active")) return;
            // Ask whether the copy is ACTUALLY truncated rather than comparing against
            // lineHeight * 4: paragraph margins add height without adding lines, so a height
            // heuristic reports "overflowing" for copy that fits and shows a SHOW MORE that
            // expands to nothing.
            description.classList.toggle("hasToggle", descriptionBody.scrollHeight > descriptionBody.clientHeight + 1);
        }

        syncDescriptionToggle();
        window.addEventListener("resize", syncDescriptionToggle);
        document.fonts?.ready.then(syncDescriptionToggle);

        // expand / collapse the description
        description.querySelector(".productV1ContentDescriptionMoreBtn")?.addEventListener("click", function () {
            description.classList.add("active");
            this.setAttribute("aria-expanded", "true");
        });
        description.querySelector(".productV1ContentDescriptionLessBtn")?.addEventListener("click", function () {
            description.classList.remove("active");
            this.setAttribute("aria-expanded", "false");
        });
    }

    /**************
     FAQ
     ***************/

    // toggle the faq list open/closed; animate height to the inner list's measured size
    section.querySelector(".productV1FAQToggle")?.addEventListener("click", function () {
        const faq = section.querySelector(".productV1FAQ");
        const wrapper = section.querySelector(".productV1FAQListWrapper");
        const list = section.querySelector(".productV1FAQList");
        const isOpen = faq.classList.toggle("active");
        this.setAttribute("aria-expanded", isOpen ? "true" : "false");
        wrapper.style.height = isOpen ? `${list.offsetHeight}px` : "0px";
    });

    /************
     Expandable Carousels
     ************/

    // Swiper can't measure inside a closed <details> (display: none), so init on first open
    section.querySelectorAll(".productV1ContentExpandablesItem").forEach(details => {
        const carouselEl = details.querySelector(".productV1ContentExpandablesItemCarousel");
        if (!carouselEl) return;

        let swiper;
        details.addEventListener("toggle", () => {
            if (!details.open) return;
            if (swiper) {
                swiper.update();
                return;
            }
            // trailing offset = container width minus one slide, so the last
            // slide can scroll all the way to the left edge instead of resting
            // on the right. recomputed on resize since it's width-dependent.
            const pinLastSlideLeft = sw => {
                const slideW = sw.slidesSizesGrid[0] || 0;
                sw.params.slidesOffsetAfter = Math.max(0, sw.width - slideW);
                sw.update();
            };
            swiper = new Swiper(carouselEl, {
                slidesPerView: 1.2,
                spaceBetween: 10,
                speed: 150,
                grabCursor: true,
                on: {
                    afterInit: pinLastSlideLeft,
                    resize: pinLastSlideLeft,
                },
            });

            // shift+wheel on desktop translates vertical scroll into slide nav
            carouselEl.addEventListener("wheel", e => {
                if (!e.shiftKey) return;
                e.preventDefault();
                const delta = e.deltaY || e.deltaX;
                if (delta > 0) swiper.slideNext();
                else if (delta < 0) swiper.slidePrev();
            }, {passive: false});
        });
    });

    /**************
     Pack Pickers
     ***************/
    // delegated handler: clicking a card's trigger toggles that card's popover (the PDP card has
    // no trigger, so it never matches)
    section.addEventListener("click", (e) => {
        const trigger = e.target.closest(".pdpUpsellItemTrigger");
        if (!trigger) return;
        const popover = trigger.closest(".pdpUpsellItem").querySelector(".pdpUpsellVariantPickerPopover");
        if (!popover) return;
        const isOpen = popover.classList.contains("active");
        closeAllPickers();
        if (!isOpen) {
            openPopover(trigger.closest(".pdpUpsellItem"), popover);
            trigger.setAttribute("aria-expanded", "true");
        }
    });

    // delegated: clicking a swatch marks it active and applies its variant to the picker
    section.addEventListener("click", (e) => {
        const swatchBtn = e.target.closest(".pdpUpsellVariantPickerPopoverSwatch");
        if (!swatchBtn) return;

        // sold-out color variants can't be selected
        if (swatchBtn.classList.contains("soldOut")) return;

        const picker = swatchBtn.closest(".pdpUpsellVariantPicker");

        // the PDP product's card drives the main color selector; updateProduct then syncs the
        // card image, active swatch and price back from the real active variant
        if (picker.dataset.pdp === "true") {
            selectPdpColor(swatchBtn.dataset.value);
            return;
        }

        picker.querySelectorAll(".pdpUpsellVariantPickerPopoverSwatch").forEach(s => s.classList.remove("active"));
        swatchBtn.classList.add("active");
        selectSwatch(picker, swatchBtn, true);
    });

    // click anywhere outside the cards closes any open popover (genuinely global, so it
    // lives on document; mousedown beats the next card's click so the swap is clean)
    document.addEventListener("mousedown", (e) => {
        if (e.target.closest(".pdpUpsellItem")) return;
        closeAllPickers();
    });

    // parse and cache a picker's per-variant data (price, compare, button colors), keyed by variant id
    function pickerData(picker) {
        if (!picker._data) {
            try {
                picker._data = JSON.parse(picker.querySelector(".pdpUpsellVariantPickerJSON").textContent);
            } catch (err) {
                console.error("PDP upsell picker JSON failed to parse:", err);
                picker._data = {};
            }
        }
        return picker._data;
    }

    // apply a swatch choice to its picker: button label/colors and the picker's selected variant
    function selectSwatch(picker, swatchBtn, rerender) {
        const data = pickerData(picker)[swatchBtn.dataset.variant] || {};
        picker.dataset.variant = swatchBtn.dataset.variant;
        picker.dataset.price = data.price;
        picker.dataset.compare = data.compare;
        // swap the card image to the chosen variant
        const cardImg = picker.closest(".pdpUpsellItem")?.querySelector(".pdpUpsellItemImage");
        if (cardImg && data.img) {
            cardImg.src = data.img;
            cardImg.srcset = data.srcset || "";
            cardImg.alt = data.alt || "";
        }
        if (rerender) renderPrice();
    }

    // initialize each picker from its first swatch (colors, label, selected variant);
    // PDP-product pickers are driven by the active variant instead, so skip them here
    section.querySelectorAll(".pdpUpsellVariantPicker").forEach(picker => {
        if (picker.dataset.pdp === "true") return;
        // prefer the first in-stock swatch; fall back to the first swatch if every color is sold out
        const firstSwatch = picker.querySelector(".pdpUpsellVariantPickerPopoverSwatch:not(.soldOut)") || picker.querySelector(".pdpUpsellVariantPickerPopoverSwatch");
        if (!firstSwatch) return;
        firstSwatch.classList.add("active");
        selectSwatch(picker, firstSwatch, false);
    });

    // seed the PDP-product pickers from the current active variant before the first price
    syncPdpPickers();

    // check the main color radio for a value, then fire change so updateProduct recomputes
    // the active variant (and syncs the PDP card image, swatch and price back)
    function selectPdpColor(colorValue) {
        const input = section.querySelector(`.productV1ContentOptionsItemColor input[value="${CSS.escape(colorValue)}"]`);
        if (!input || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event("change", {bubbles: true}));
    }

    // sync every PDP-product card picker to the active variant: swap its image, mark the
    // matching color swatch, and align its dataset so pricing/ATC use the real variant
    function syncPdpPickers() {
        const colorInput = section.querySelector(".productV1ContentOptionsItemColor input:checked");
        const colorValue = colorInput ? colorInput.value : null;
        section.querySelectorAll('.pdpUpsellVariantPicker[data-pdp="true"]').forEach(picker => {
            picker.dataset.variant = activeVariant.id;
            picker.dataset.price = activeVariant.price;
            picker.dataset.compare = activeVariant.compare_at_price || 0;

            picker.querySelectorAll(".pdpUpsellVariantPickerPopoverSwatch").forEach(swatch => {
                swatch.classList.toggle("active", swatch.dataset.value === colorValue);
            });

            const img = picker.closest(".pdpUpsellItem").querySelector(".pdpUpsellItemImage");
            if (img && activeVariant.featured_image) {
                img.src = `${activeVariant.featured_image.src}&width=240`;
                img.removeAttribute("srcset");
                img.alt = activeVariant.featured_image.alt || "";
            }
        });
    }

    // price the initially selected card now that the pickers are populated
    renderPrice();

    // position and open a picker's popover, pointing its arrow at the card
    function openPopover(card, popover) {
        popover.classList.add("active");
        const row = card.parentElement;
        const rowRect = row.getBoundingClientRect();
        const popoverRect = popover.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const isMobile = window.matchMedia("(max-width: 800px)").matches;
        if (isMobile) {
            // mobile: item is positioned, so the CSS default handles vertical placement
            popover.style.bottom = "";
            // mobile: popover is centered in the row, so aim the arrow at the card
            popover.style.left = "";
            const cardCenter = cardRect.left + (cardRect.width / 2);
            const arrowX = cardCenter - popoverRect.left - 17.5;
            popover.style.setProperty("--arrow-x", `${arrowX}px`);
        } else {
            // desktop: item is static so the popover anchors to the whole multi-row body; pin its bottom to the clicked card's top so it sits above that row
            popover.style.bottom = `${rowRect.bottom - cardRect.top + 4}px`;
            // desktop: clamp the popover inside the row, arrow 40% from the card's left
            const arrowTarget = cardRect.left + (cardRect.width * 0.4);
            let left = arrowTarget - rowRect.left - (popoverRect.width / 2);
            const maxLeft = rowRect.width - popoverRect.width;
            left = Math.max(0, Math.min(left, maxLeft));
            popover.style.left = `${left}px`;
            const arrowX = arrowTarget - (rowRect.left + left) - 17.5;
            popover.style.setProperty("--arrow-x", `${arrowX}px`);
        }
    }

    // close every open card popover (and reset its trigger's aria-expanded)
    function closeAllPickers() {
        section.querySelectorAll(".pdpUpsellItemTrigger[aria-expanded='true']").forEach(t => {
            t.setAttribute("aria-expanded", "false");
            t.closest(".pdpUpsellItem").querySelector(".pdpUpsellVariantPickerPopover").classList.remove("active");
        });
    }

    /************
     Badges
     ************/

    // toggle a badge's info popover; clicking another badge or outside closes any open one
    section.addEventListener("click", (e) => {
        const infoBtn = e.target.closest(".productV1ContentInfoBadgesItemInfo");
        if (!infoBtn) return;
        const badge = infoBtn.closest(".productV1ContentInfoBadgesItem");
        const popover = badge.querySelector(".productV1ContentInfoBadgesItemPopover");
        const willOpen = !popover.classList.contains("active");
        // close all open badge popovers before toggling this one
        section.querySelectorAll(".productV1ContentInfoBadgesItemPopover.active").forEach(p => {
            p.classList.remove("active");
            p.closest(".productV1ContentInfoBadgesItem").querySelector(".productV1ContentInfoBadgesItemInfo").setAttribute("aria-expanded", "false");
        });
        if (willOpen) {
            popover.classList.add("active");
            infoBtn.setAttribute("aria-expanded", "true");
        }
    });

    // close badge popover when clicking outside
    document.addEventListener("mousedown", (e) => {
        if (e.target.closest(".productV1ContentInfoBadgesItem")) return;
        section.querySelectorAll(".productV1ContentInfoBadgesItemPopover.active").forEach(p => {
            p.classList.remove("active");
            p.closest(".productV1ContentInfoBadgesItem").querySelector(".productV1ContentInfoBadgesItemInfo").setAttribute("aria-expanded", "false");
        });
    });
}());